<template>
  <BaseIndex ref="baseIndex" :loading="loading" :pageLoading="pageLoading" :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural" :table-headers="tableHeaders" :table-items="nfces" :maskFields="maskFields"
    :indexErrors="indexErrors" @clear-index-errors="indexErrors = []" @options-change="optionsChange"
    :serverItemsLength="totalItems" :loadOptions="options" :enableCustomFilters="true" :containTopToolbar="false"
    :typeOperators="typeOperators" :serverFields="serverFields" @filter-confirm-action="applyFilters"
    id="nfcesPrintTable">
    <template slot="print">
      <BasePrint printableElementId="nfcesPrintTable" printButtonLabel="Imprimir"
        printTitle="Notas fiscais eletrônicas do consumidor" @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false" />
    </template>

    <template v-if="item.cashFlow" slot="link1" slot-scope="{ item }">
      <SaleEdit :entry="item.cashFlow" @entry-updated="entryUpdated"
        :editTitle="'Visualizar Venda ' + item.cashFlow.code" editIcon="mdi-handshake"
        :readOnly="item.statusKey == 'processing' || item.statusKey == 'sending' || item.statusKey == 'waiting_for_response' || item.statusKey == 'authorized'"
        :isTextButton="true" :textButton="'Venda ' + item.cashFlow.code" modelNameSingular="Venda" />
    </template>

    <template slot="new" v-if="$route.query.saleId">
      <v-btn @click="redirectToNfces()">
        Ver todas as NFC-es
      </v-btn>
      <!-- <New
        @entry-created="entryCreated"
      /> -->
    </template>

    <template v-if="item.canBeReissued" slot="edit" slot-scope="{ item }">
      <Edit :entry="item" @entry-updated="entryUpdated" :modelNameSingular="modelNameSingular" />
    </template>

    <!-- <template slot="delete" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
      />
    </template> -->

    <!-- Exibe mensagem com erro ou confirmacao -->
    <template v-if="item.nsXmotivo" slot="action1" slot-scope="{ item }">
      <v-tooltip top
        :color="item.statusKey == 'authorized' ? 'success' : item.statusKey == 'canceled' ? 'warning' : 'error'">
        <template v-slot:activator="{ on }">
          <v-icon
            :color="item.statusKey == 'authorized' ? 'success' : item.statusKey == 'canceled' ? 'warning' : 'error'"
            dark v-on="on" class="mx-1">
            {{ item.statusKey == 'authorized' ? 'mdi-file-check' : item.statusKey == 'canceled' ? 'mdi-file-cancel' :
            'mdi-alert'}}
          </v-icon>
        </template>
        <span>{{ item.nsXmotivo }}</span>
      </v-tooltip>
    </template>


    <template
      v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'sending' || item.statusKey == 'waiting_for_response' || item.statusKey == 'retrieving_status_failed'"
      slot="action2" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-icon v-on="{ ...tooltip }" class="mx-1" @click="refreshNfceStatus(item)">
            mdi-refresh
          </v-icon>
        </template>
        <span>Atualizar Status da emissão da NFC-e</span>
      </v-tooltip>
    </template>

    <!-- <template v-if="item.status == 'authorized'" slot="action2" slot-scope="{ item }">
      <v-icon
        @click="downloadNfePdf(item, 'Danfe')"
        small
        class="mr-2"
        title="Download da Danfe"
      >
        mdi-file-download
      </v-icon>
    </template> -->

    <template v-if="item.statusKey == 'authorized' || item.statusKey == 'canceled'" slot="action3"
      slot-scope="{ item }">
      <BasePdfViewer v-if="item.statusKey == 'authorized' && item.type == 'NFCE'" :pdfSource="item.pdf" :loading="false"
        :pdfTitle="'NFC-e-' + item.series + '-' + item.number"
        @pdf-open-action="getNfcePdf(item, function () { return null; })" ref="nfcePdfRef" />
      <!-- <BasePdfViewer v-if="item.statusKey == 'authorized' && item.type == 'NFPE'"
        :pdfSource="item.pdf"
        :loading="false"
        :pdfTitle="'NF-e-' + item.series + '-' + item.number"
        @pdf-open-action="getNfePdf(item, function() {return null;})"
        ref="nfePdfRef"
      /> -->
      <BasePdfViewer v-if="item.statusKey == 'canceled'" :pdfSource="item.pdf" :loading="false"
        pdfTitle="Danfe de Cancelamento" @pdf-open-action="getNfceCancellationPdf(item, function () { return null; })"
        ref="nfceCancellationPdfRef" />
    </template>

    <!-- <template v-if="item.status == 'authorized'" slot="action4" slot-scope="{ item }">
      <v-icon
        @click="downloadNfeXml(item, 'Xml NF-e')"
        small
        class="mr-2"
        title="Download do XML da NF-e"
      >
        mdi-xml
      </v-icon>
    </template> -->

    <template v-if="item.statusKey == 'authorized' || item.statusKey == 'canceled'" slot="action5"
      slot-scope="{ item }">
      <!-- <BaseXmlViewer v-if="item.statusKey == 'authorized' && item.type == 'NFPE'"
        :xmlSource="item.xml"
        :loading="false"
        :xmlTitle="'NF-e-' + item.series + '-' + item.number"
        @xml-open-action="getNfeXml(item, function() {return null;})"
        ref="nfeXmlRef"
      /> -->
      <BaseXmlViewer v-if="item.statusKey == 'authorized' && item.type == 'NFCE'" :xmlSource="item.xml" :loading="false"
        :xmlTitle="'NFC-e-' + item.series + '-' + item.number"
        @xml-open-action="getNfceXml(item, function () { return null; })" ref="nfceXmlRef" />
      <BaseXmlViewer v-if="item.statusKey == 'canceled'" :xmlSource="item.xml" :loading="false"
        xmlTitle="Danfe XML de Cancelamento" @xml-open-action="getNfceCancellationXml(item, function () { return null; })"
        ref="nfceCancellationXmlRef" />
    </template>



    <template v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'authorized'" slot="action7"
      slot-scope="{ item }">
      <!-- Delete was used to cancel the NFe -->
      <Delete :entry="item" @entry-destroyed="entryDeleted" :modelNameSingular="modelNameSingular" />
    </template>

    <template slot="action8" slot-scope="{ item }">
      <v-icon @click="openSefazUrl(item)" class="mx-1">
        mdi-receipt
      </v-icon>
    </template>


    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="6" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.totalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>

</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import BasePdfViewer from "@shared_components/base_pdf_viewer.vue";
import BaseXmlViewer from "@shared_components/base_xml_viewer.vue";
import BasePrint from "@shared_components/base_print.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import SaleEdit from "@models/sales/edit.vue";

export default {
  data() {
    return {
      nfces: [],
      statusRequests: 0,
      loading: true,
      pageLoading: false,
      indexErrors: [],
      totalPrice: null,
      totalItems: 0,
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Série", align: "left", sortable: true, value: "series" },
        { text: "Número", align: "left", sortable: true, value: "number" },
        { text: "Cliente", align: "left", sortable: true, value: "cashFlow.customer.name" },
        { text: "CHNFE", align: "left", sortable: true, value: "nsChnfe" },
        { text: "CFOP", align: "left", sortable: true, value: "cfop.code" },
        { text: "Emitido em", align: "left", sortable: true, value: "issueDate" },
        { text: "Valor", align: "left", sortable: true, value: "vNf" },
        { text: "Status", align: "left", sortable: true, value: "status" },
        { text: "Venda", align: "left", sortable: false, value: "link" },
        // { text: "Tipo", align: "left", sortable: false, value: "type" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'issueDate', mask: 'date' },
        { field: 'vNf', mask: 'currency' },
        { field: 'series', mask: 'nfe_serie' },
        { field: 'number', mask: 'nfe_number' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "NFC-e"
    },
    modelNamePlural: {
      type: String,
      default: "NFC-es"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BasePdfViewer: BasePdfViewer,
    BaseXmlViewer: BaseXmlViewer,
    SaleEdit: SaleEdit,
    BasePrint: BasePrint,
  },
  created() {
    // this.loadServerEntries();
  },
  methods: {
    openSefazUrl: function(item){
      navigator.clipboard.writeText(item.nsChnfe);
      window.open("https://sefaz.rs.gov.br/NFE/NFE-NFC.aspx", "_blank").focus();
    },
    applyFilters: function (filtersList) {
      this.filters = filtersList;
      this.loadServerEntries();
    },
    loadServerEntries: function () {
      let route = this.$route;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_NFCES,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters
            },
            saleId: route.query.saleId ? route.query.saleId : null
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // if (route.query.saleId) {
          //   this.allNfes = response.data.accountContext.nfesIndex.nfes;
          //   this.nfes = _.filter(this.allNfes, function(nfe) {
          //     return nfe.cashFlow.id == route.query.saleId;
          //   });
          // } else {
          this.nfces = response.data.accountContext.nfcesIndex.nfces;

          this.totalItems = response.data.accountContext.nfcesIndex.count;
          this.typeOperators = response.data.accountContext.nfcesIndex.typeOperators;
          this.serverFields = response.data.accountContext.nfcesIndex.serverFields;

          this.totalPrice = 0;
          for (var nfce in this.nfces) {
            this.totalPrice += this.nfces[nfce].vNf;
          }
          this.totalPrice = _.round(this.totalPrice, 2);

          // console.log(this.totalItems, this.typeOperators, this.serverFields)
          // }
          // console.log("All NFCEs", this.nfces);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function () {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("NF-e reenviada com sucesso!");
    },
    entryCreated: function () {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("NF-e enviada com sucesso!");
    },
    entryDeleted: function () {
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Cancelamento da NF-e enviado com sucesso!");
    },
    redirectToNfces: function () {
      this.$router.push({ name: "OutboundNfce" });
      this.nfces = this.allNfces;
      this.loadServerEntries();
    },
    refreshNfceStatus: function (nfce) {
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: UPDATE_NFCE_STATUS_MUTATION,
          variables: {
            input: {
              nfpeId: nfce.id
            }
          },
        })
        .then(response => {
          //console.log(response.data.retrieveNfpeStatus)
          let errors = response.data.retrieveNfceStatus.errors
          if (errors.length) {
            // this.$refs.baseIndex.showErrorMessage(errors);
            this.$set(this, 'indexErrors', errors);
            // this.indexErrors = errors;
          } else {
            var response_nfce = response.data.retrieveNfceStatus.nfpe
            if (response_nfce) {
              nfce.status = response_nfce.status;
              nfce.statusKey = response_nfce.statusKey;
              nfce.nsXmotivo = response_nfce.nsXmotivo;
            } else {
              this.$set(this, 'indexErrors', ["Não foi possível consultar o status. Tente novamente mais tarde."]);
            }
          }

        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfcePdf: function (nfce, fileName) {
      this.getNfcePdf(nfce, function (pdfFile) {
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfcePdf: function (nfce, callback) {
      if (nfce.pdf) {
        callback(nfce.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFCE_PDF_MUTATION,
          variables: {
            nfpeId: nfce.id
          },
        })
        .then(response => {
          var response_data = ""
          response_data = response.data.downloadNfcePdf
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0) {
            this.indexErrors = errors;
            this.$refs.nfcePdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.nfpe.nfePdf
            this.$set(nfce, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfceCancellationPdf: function (nfce, fileName) {
      this.getNfceCancellationPdf(nfce, function (pdfFile) {
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfceCancellationPdf: function (nfce, callback) {
      if (nfce.pdf) {
        callback(nfce.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFCE_CANCELLATION_PDF_MUTATION,
          variables: {
            nfpeId: nfce.id
          },
        })
        .then(response => {
          var response_data = ""
          response_data = response.data.downloadNfceCancellation
          var errors = response_data.errors
          console.log(errors)
          if (errors.length > 0) {
            this.indexErrors = errors;
            this.$refs.nfceCancellationPdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.nfpe.nfeCancellationPdf;
            this.$set(nfce, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfceXml: function (nfce, fileName) {
      this.getNfceXml(nfce, function (xmlString) {
        let bb = new Blob([xmlString], { type: 'text/plain' });
        let xmlFile = window.URL.createObjectURL(bb);
        const downloadLink = document.createElement("a");
        downloadLink.href = xmlFile;
        downloadLink.download = fileName + '.xml';
        downloadLink.click();
      });
    },
    getNfceXml: function (nfce, callback) {
      // console.log("chamou XML");
      if (nfce.pdf) {
        callback(nfce.xml);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFCE_XML_MUTATION,
          variables: {
            nfpeId: nfce.id
          },
        })
        .then(response => {
          var errors = response.data.downloadNfceXml.errors
          console.log(errors)
          if (errors.length) {
            this.indexErrors = errors;
            this.$refs.nfceXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadNfceXml.nfpe.nfeXml;
            this.$set(nfce, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfceCancellationXml: function (nfce, fileName) {
      this.getNfceCancellationXml(nfce, function (xmlString) {
        let bb = new Blob([xmlString], { type: 'text/plain' });
        let xmlFile = window.URL.createObjectURL(bb);
        const downloadLink = document.createElement("a");
        downloadLink.href = xmlFile;
        downloadLink.download = fileName + '.xml';
        downloadLink.click();
      });
    },
    getNfceCancellationXml: function (nfce, callback) {
      // console.log("chamou XML");
      if (nfce.pdf) {
        callback(nfce.xml);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFCE_CANCELLATION_XML_MUTATION,
          variables: {
            nfpeId: nfce.id
          },
        })
        .then(response => {
          var errors = response.data.downloadNfceCancellation.errors
          console.log(errors)
          if (errors.length) {
            this.indexErrors = errors;
            this.$refs.nfceCancellationXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadNfceCancellation.nfpe.nfeCancellationXml;
            this.$set(nfce, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    optionsChange: function (opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_NFCES = gql`
  query($input: IndexInputObject!, $saleId: ID) {
  	accountContext {
      nfcesIndex(input: $input, saleId: $saleId) {
        count
        nfces {
          id
          code
          series
          number
          type
          cfopId
          cfop {
            text
            code
            description
          }
          status
          statusKey
          statusValue
          deliveredReceivedDate
          deliveredReceivedTime
          issueDate
          issueTime
          mailingList
          nsXmotivo
          vNf
          canBeReissued
          cashFlow {
            id
            code
            customer {
              id
              name
            }
          }
          nsChnfe
        }
        serverFields
        typeOperators
      }
    }
  }
`;

const UPDATE_NFCE_STATUS_MUTATION = gql`
  mutation($input: RetrieveNfpeStatusInputObject!) {
    retrieveNfceStatus(input: $input) {
      nfpe {
        id
        status
        statusKey
        statusValue
        nsXmotivo
      }
      errors
    }
  }
`;

const DOWNLOAD_NFCE_PDF_MUTATION = gql`
  mutation($nfpeId: ID!){
    downloadNfcePdf(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfePdf
      }
      errors
    }
  }
`;

const DOWNLOAD_NFCE_XML_MUTATION = gql`
  mutation($nfpeId: ID!){
    downloadNfceXml(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeXml
      }
      errors
    }
  }
`;

const DOWNLOAD_NFCE_CANCELLATION_XML_MUTATION = gql`
  mutation($nfpeId: ID!){
    downloadNfceCancellation(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeCancellationXml
      }
      errors
    }
  }
`;

const DOWNLOAD_NFCE_CANCELLATION_PDF_MUTATION = gql`
  mutation($nfpeId: ID!){
    downloadNfceCancellation(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeCancellationPdf
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
